import React from 'react';

import { Block }             from '../../atoms/Layout/Block/Block';
import { Game }              from '../../models/Game';
import { User }              from '../../models/User';
import RecentlyPlayedService from '../../services/RecentlyPlayedService';
import { Recommendations }   from './Recommendations';

type RecentlyPlayedGamesProps = {
    games: Game[],
    user: User,
    className?: string;
};

export class RecentlyPlayedGames extends React.PureComponent<RecentlyPlayedGamesProps> {
    state = {
        games: [],
    };

    async loadGames() {
        const { games, user } = this.props;
        const recentlyPlayed = await RecentlyPlayedService.read(games, user);
        this.setState({
            games: recentlyPlayed.slice(0, 3),
        });
    }

    componentDidMount() {
        this.loadGames();
    }

    componentDidUpdate(prevProps: RecentlyPlayedGamesProps) {
        if (this.props.user !== prevProps.user) {
            this.loadGames();
        }
    }

    render() {
        if (!this.state.games.length) { return null; }

        return (
            <Block paddingB = "xxl" className = {this.props.className}>
                <Recommendations
                    title = "Recently Played"
                    description = "recently played"
                    games = {this.state.games}
                />
            </Block>
        );
    }
}
